import { Container } from "@chakra-ui/react";
import React from "react";
import Education from "./Education";
import TopPart from "./TopPart";
// import Education from "./Education";
// import Head from "./Head";
const About = () => {
    const edu = [
        {
            insName: "Collectorate School And Collage",
            title: "Secondary School",
            grade: "3 Years To Complete. Grade was Gpa 3.21.",
            duration: "2010 - 2012",
            web: "https://www.sohopathi.com/babupur-kasim-uddin-bidyapith/",
            text: "This is a high school located in rajbari district ,bangladesh ",
        },
        {
            insName: "Rangpur Govt Collage",
            title: "Higher Secondary School",
            grade:
                "2 years to complete. Subject was Science. Dropped from 2nd year.",
            duration: "2013-2015",
            web: "https://www.rangpur.gov.bd/",
            text: 'This is a college located in Rangpur, bangladesh '
        },
        {
            insName: "Daffodil International University",
            title: "Bachelor of Computer Science And Engineering",
            grade:
                "4 years to complete",
            duration: "2017-2021",
            web: "https://daffodilvarsity.edu.bd",
            text: '4 years Bachelor Degree Completed in Computer Science And Engineering.'
        },
    ];
    const courses = [
        {
            insName: "Creative It Institute",
            title: "Web Developer",
            grade:
                "3 month course covered html, css, PHP. I have completed this course and got certified.",
            duration: "2017-2017",
            web: "https://www.creative-it.com/",
            text: "This is a Private Academy who teaches Programming and web-development, They are located in Science-lab dhaka, bangladesh",
        },
        {
            insName: "Programming-Hero.com",
            title: "Complete Full Stack Web Development",
            grade:
                "Online based course of web development with react.js, node.js, express.js, mongoDb,firebase, sass,bootstrap, tailwind css.",
            duration: "2022-2022",
            web: "https://web.programming-hero.com/",
            text: 'Well this course was something special because this course instructed by Jhankar Mahbub a very famous web developer and author of some very famous book of programming in bangladesh, this course completed everything about web development.'
        },
    ];
    const exp = [
        {
            insName: "Binarycloth LTD",
            title: "Web Engineer",
            grade:
                "Worked at Binarycloth Limited as web designer and developer and also as a DATA Analyser.",
            duration: "2021-2022",
            web: "https://www.binarycloth.com",
            text: "This is a new company.",
        },
        {
            insName: "Freelancer",
            title: "Freelancing",
            grade:
                "After Learning JS, React, Wordpress, SEO, AE, PS, I started freelancing (As my Practice more and gain more knowledge)",
            duration: "2022 - Running",
            web: "https://www.google.com/",
            text: 'There are many freelancing websites, where customer can done their work by posting their work in those particular site and the freelancers can find their work in here at same time '
        },
    ];
    return (
        <Container maxW={"container.lg"}>
            <TopPart />
            <Education
                edu={edu}
                name="Academic Carrier ."
                title="Here is some info about my Academic Carrier."
            />
            <Education edu={courses}
                name="Private Courses ."
                title="Here is some info about my programming journey. "
            />
            <Education
                edu={exp}
                name="Experiences ."
                title="Here is some info about my experiences."
            />

        </Container>
    );
};

export default About;
